import axios, { AxiosInstance } from 'axios'
import HTTPConverter from './converters/HTTPConverter.ts'
import generalErrorConverter from './converters/GeneralErrorConverter.ts'

export class ApiKeyTripbookRepository {
    private client: AxiosInstance

    get serverBaseURL(): string {
        return import.meta.env.VITE_APP_SERVER_URL
    }

    constructor(apiKey: string) {
        this.client = axios.create({
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Api-Key': apiKey,
            },
            timeout: 40000,
            validateStatus: (status) => status >= 200 && status < 300,
        })

        this.client.interceptors.response.use(
            (response) => HTTPConverter.fromResponse(response),
            (err) => Promise.reject(generalErrorConverter.fromBackendServerError(err))
        )
    }

    getAgency(): Promise<any> {
        return this.client.get(`${this.serverBaseURL}/agencies/me`)
    }

    createTripbook(tripbook: any): Promise<any> {
        return this.client.put(`${this.serverBaseURL}/invitation-codes`, tripbook)
    }
}
